








import {Component, Vue} from 'vue-property-decorator';
import JdsIcon from "@/design-system/icons/JdsIcon.vue"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"

@Component({
    components: {JdsGlyph, JdsIcon}
})
export default class JdsLocation extends Vue {
}
